export default __webpack_public_path__ + "static/media/ssc-hxln-shengxin.be2d3e37.png";